const headerMenuButton = document.querySelector("#header-mobile-menu-button");
const headerMobileMenu = document.querySelector("#header-mobile-menu");
const headerSearchMenuButton = document.querySelector("#header-mobile-search-menu-button");
const headerMobileSearchMenu = document.querySelector("#header-mobile-search-menu");

function menuOpen() {
  if (headerMobileMenu && headerMenuButton) {
    headerMobileMenu.classList.add("open");
    headerMobileMenu.setAttribute("aria-hidden", "false");

    headerMenuButton.setAttribute("aria-label", "メニューを閉じる");
    headerMenuButton.setAttribute("aria-expanded", "true");
  }
}

function menuClose() {
  if (headerMobileMenu && headerMenuButton) {
    headerMobileMenu.classList.remove("open");
    headerMobileMenu.setAttribute("aria-hidden", "true");

    headerMenuButton.setAttribute("aria-label", "メニューを開く");
    headerMenuButton.setAttribute("aria-expanded", "false");
  }
}

function searchMenuOpen() {
  if (headerMobileSearchMenu && headerSearchMenuButton) {
    headerMobileSearchMenu.classList.add("open");
    headerMobileSearchMenu.setAttribute("aria-hidden", "false");

    headerSearchMenuButton.setAttribute("aria-label", "メニューを閉じる");
    headerSearchMenuButton.setAttribute("aria-expanded", "true");
  }
}

function searchMenuClose() {
  if (headerMobileSearchMenu && headerSearchMenuButton) {
    headerMobileSearchMenu.classList.remove("open");
    headerMobileSearchMenu.setAttribute("aria-hidden", "true");

    headerSearchMenuButton.setAttribute("aria-label", "メニューを開く");
    headerSearchMenuButton.setAttribute("aria-expanded", "false");
  }
}

headerMenuButton?.addEventListener("click", () => {
  if (headerMobileMenu) {
    const isOpen = headerMobileMenu.classList.contains("open");

    if (isOpen) {
      menuClose();
    } else {
      searchMenuClose();
      menuOpen();
    }
  }
});

headerSearchMenuButton?.addEventListener("click", () => {
  if (headerMobileSearchMenu) {
    const isOpen = headerMobileSearchMenu.classList.contains("open");

    if (isOpen) {
      searchMenuClose();
    } else {
      menuClose();
      searchMenuOpen();
    }
  }
});

const matchMedia = window.matchMedia("(max-width: 1023px)");
matchMedia.addEventListener("change", () => {
  if (!matchMedia.matches) {
    // PC
    menuClose();
    searchMenuClose();
  }
});